module.exports = __webpack_public_path__ + "static/media/cristina_gunea.e7016596.jpg";